import ApiClient from "~/admin/services/ApiClient";

export default class LoginApi {
  static login = (data) => ApiClient.post("login", data);
  static logout = () => ApiClient.get("logout");
}
